import { Check, X } from 'lucide-react';
import type { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { ActionsCard, CancelButton, ConfirmButton } from './styles';

export interface InlineEditActionsProps {
  /** ✕ — discard the edit. */
  onCancel: (event: MouseEvent<HTMLButtonElement>) => void;
  /** ✓ — keep the edit. */
  onConfirm: (event: MouseEvent<HTMLButtonElement>) => void;
  /** Positions the card; the card itself is static. */
  className?: string;
}

/**
 * The ✕/✓ card shown under a field while it is being edited — Figma `inline-edit-input`
 * (Active, `7666:17290`): ✕ in a 32px button with a 10px cross, ✓ in a 26px one with a
 * 12px tick, 8px apart on a floating card.
 */
export default function InlineEditActions({
  onCancel,
  onConfirm,
  className,
}: InlineEditActionsProps) {
  const { t } = useTranslation('dashboard', { keyPrefix: 'global' });

  return (
    <ActionsCard className={className}>
      <CancelButton
        type='button'
        aria-label={t('cancel')}
        data-testid='discard-changes-button'
        onClick={onCancel}
      >
        <X size={20} aria-hidden />
      </CancelButton>
      <ConfirmButton
        type='button'
        size='small'
        aria-label={t('save')}
        data-testid='accept-changes-button'
        onClick={onConfirm}
      >
        <Check strokeWidth={2.5} size={18} aria-hidden />
      </ConfirmButton>
    </ActionsCard>
  );
}
